import axios from "axios";
import { useEffect, useState } from "react";
import { today } from "./format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const emptyForm = () => ({
  kind: "expense",
  amount: "",
  gross_revenue: "",
  commission: "",
  commission_rate: "",
  commission_mode: "percent",
  currency: "TRY",
  transaction_date: today(),
  description: "",
  group: "Diğer",
  account: "",
  recurring: false,
});

export const CURRENCIES = ["TRY", "USD", "AED", "EUR"];
export const currencyRateOf = (currency, rates) => currency === "TRY" ? 1 : (rates?.[currency] || null);

export const formFromTransaction = tx => ({
  kind: tx.kind,
  amount: String(tx.amount),
  gross_revenue: tx.gross_revenue != null ? String(tx.gross_revenue) : "",
  commission: tx.commission ? String(tx.commission) : "",
  commission_rate: tx.commission_rate != null ? String(tx.commission_rate) : "",
  commission_mode: tx.commission_rate != null ? "percent" : "amount",
  currency: tx.currency,
  transaction_date: tx.transaction_date,
  description: tx.description,
  group: tx.group,
  account: tx.account || "",
  recurring: false,
});

export const commissionOf = form => {
  const revenue = Number(form.gross_revenue || 0);
  if (form.commission_mode === "percent") return Math.round(revenue * Number(form.commission_rate || 0)) / 100;
  return Number(form.commission || 0);
};

export const netOf = form => {
  if (form.kind !== "income") return Number(form.amount || 0);
  return Math.round(commissionOf(form) * 100) / 100;
};

export const buildPayload = (form, rate, rates) => {
  const income = form.kind === "income";
  const percent = form.commission_mode === "percent";
  return {
    kind: form.kind,
    amount: netOf(form),
    gross_revenue: income ? Number(form.gross_revenue) : null,
    commission: income ? commissionOf(form) : 0,
    commission_rate: income && percent ? Number(form.commission_rate || 0) : null,
    currency: form.currency,
    transaction_date: form.transaction_date,
    description: form.description,
    group: form.group,
    account: income ? form.account : null,
    rate: rate || null,
    currency_rate: currencyRateOf(form.currency, rates),
    recurring: form.kind === "expense" && !!form.recurring,
  };
};

export const validate = form => {
  const amount = netOf(form);
  if (!amount || amount <= 0) return form.kind === "income" ? "Komisyon sıfırdan büyük olmalı" : "Tutar sıfırdan büyük olmalı";
  if (form.kind === "income" && !form.account) return "Gelir kaydı için hesap seçilmelidir";
  if (form.kind === "income" && commissionOf(form) > Number(form.gross_revenue || 0)) return "Komisyon cirodan büyük olamaz";
  if (form.kind === "income" && form.commission_mode === "percent" && Number(form.commission_rate || 0) > 100) return "Komisyon oranı %100'ü aşamaz";
  return "";
};

export function useDateRate(day) {
  const [state, setState] = useState({ rate: 0, rates: {}, source: "", loading: false });
  useEffect(() => {
    if (!day) return;
    let cancelled = false;
    setState(s => ({ ...s, loading: true }));
    axios.get(`${API}/rates/tcmb?day=${day}&prefer_manual=true`)
      .then(({ data }) => !cancelled && setState({ rate: data.rate, rates: data.rates || { USD: data.rate }, source: data.source, loading: false }))
      .catch(() => !cancelled && setState({ rate: 0, rates: {}, source: "kur alınamadı", loading: false }));
    return () => { cancelled = true; };
  }, [day]);
  return state;
}
